"use client"

import { Edit, Plus } from "lucide-react"
import { useState } from "react"
import { Button } from "@/components/ui/button"
import { Card } from "@/components/ui/card"
import WorkflowReminder from "./workflow"
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import ReminderTemplates from "./reminder-templates"
import WorkflowForm from "../../modal/workflow-form"
import ReminderTemplatesForm from "../../modal/reminder-template-form"
import { useGetEmailTemplatesQuery, useGetInvoiceRemindersQuery } from "@/services/systemConfigApi"
import { Action } from "@radix-ui/react-toast"
import { InvoiceReminders } from "@/types/system-setting/system-config"

export default function InvoiceReminderWorkflow() {
    const [action, setAction] = useState<'add' | 'edit'>('add')
    const [workflowAction, setWorkflowAction] = useState<'add' | 'edit'>('add')
    const [selectedTab, setSelectedTab] = useState("workflow")
    const [showEditWorkflow, setShowEditWorkflow] = useState(false)
    const [showAddReminder, setShowAddReminder] = useState(false)
    const tabs = [
        {
            value: "workflow",
            label: "Workflow",
        },
        {
            value: "reminder-template",
            label: "Reminder Template",
        },
    ]

    const handleTabChange = (value: string) => {
        setSelectedTab(value)
    }

    console.log({ selectedTab })

    const { data: workflow, refetch } = useGetInvoiceRemindersQuery()

    const { data: reminderTemplates, refetch: reminderRefetch } = useGetEmailTemplatesQuery(
        {
            query: "",
        }
    )
    return (
        <div className=" p-4  mx-auto border-[1px] border-gray-200 rounded-md">
            <Tabs
                value={selectedTab}
                onValueChange={handleTabChange}
                className="w-full">

                <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 sm:gap-0 mb-6">
                    <h1 className="text-base sm:text-lg font-medium text-gray-700">{selectedTab == "workflow" ? "Invoice Reminder Workflow" : "Reminder Templates"}</h1>
                    <div className="flex gap-2 self-end sm:self-auto">
                        <Button
                            title={selectedTab == "workflow" ? "Edit Workflow" : "Add Invoice Reminder"}
                            size="icon"
                            variant="default"
                            onClick={() => {
                                if (selectedTab == "workflow") {
                                    setShowEditWorkflow(true)
                                    setWorkflowAction("edit")
                                } else {
                                    setShowAddReminder(true)
                                    setAction("add")
                                }
                            }}
                            className="bg-primary hover:bg-green-500 h-9 w-9 rounded-lg">
                            {selectedTab == "workflow" ? <Edit className="text-black h-5 w-5" />
                                : <Plus className="text-black h-5 w-5" />}
                            <span className="sr-only">Edit</span>
                        </Button>
                        <div className="flex rounded-md overflow-hidden">
                            <TabsList className="p-1">
                                {tabs
                                    .map((tab) => (
                                        <TabsTrigger
                                            key={tab.value}
                                            value={tab.value}
                                            className="data-[state=active]:bg-primary"
                                        >
                                            {tab.label}
                                        </TabsTrigger>
                                    ))}
                            </TabsList>
                        </div>
                    </div>
                </div>

                <TabsContent value="workflow" className="w-full">
                    <WorkflowReminder workflow={workflow as InvoiceReminders} />
                </TabsContent>

                <TabsContent value="reminder-template" className="w-full">
                    <ReminderTemplates />
                </TabsContent>
            </Tabs>
            <WorkflowForm
                isOpen={showEditWorkflow}
                setOpen={setShowEditWorkflow}
                action={workflowAction}
                setAction={setWorkflowAction}
                refetch={refetch}
                editModeData={workflow}
            />
            <ReminderTemplatesForm
                isOpen={showAddReminder}
                setOpen={setShowAddReminder}
                action={action}
                setAction={setAction}
                refetch={reminderRefetch}
                editModeData={[]}
            />

        </div>
    )
}
